import { render, staticRenderFns } from "./modifyHandler.vue?vue&type=template&id=186349e5"
import script from "./modifyHandler.vue?vue&type=script&lang=js"
export * from "./modifyHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports